import { Entity, CodeType, CodeCategory, ActivityEntityName } from './index';

/// Legacy will be deleted in the future
// export enum PriceBookType {
//     Sell = 'SELL',
//     Buy = 'BUY'
// }

export enum PriceListMode {
    Static = 'Static',
    Dynamic = 'Dynamic'
}

export enum PricingMethod {
    //Markup % on Cost, only for catalogue option
    CostPlus = 'CostPlus',
    //Markup % on Trade, only for catalogue option
    TradePlus = 'TradePlus',
    //Markdown % on Sale, only for catalogue option
    SellLess = 'SellLess',
    //Markup % - only appears for reference pricebook
    Markup = 'Markup',
    //Margin % - appears for reference pricebook
    Margin = 'Margin',

    PriceList = 'PriceList',
    RetailPrice = 'Retail Price',
    MarkupOnRetailPrice = "Markup On Retail Price",
    Manual = 'Manual'
}

export const PricingMethods = {
    [PricingMethod.CostPlus]: {
        label: 'Markup % on Cost',
        showForCatalog: true,
        showForReference: false
    },
    [PricingMethod.TradePlus]: {
        label: 'Markup % on Trade',
        showForCatalog: true,
        showForReference: false
    },

    [PricingMethod.SellLess]: {
        label: 'Markdown % on Sell',
        showForCatalog: true,
        showForReference: false
    },

    [PricingMethod.Markup]: {
        label: 'Markup %',
        showForCatalog: false,
        showForReference: true
    },

    [PricingMethod.Margin]: {
        label: 'Margin %',
        showForCatalog: true,
        showForReference: true
    },
}

export enum PriceListCategory {

    // Special Case
    Catalogue = 'Catalogue',

    Customer = 'Customer',
    Contractor = 'Contractor',
    Supplier = 'Supplier'
}

export enum PricelistStatus {
    All = 'All',
    Current = 'Current',
    Future = 'Future',
    Expired = 'Expired'
}

export interface PriceBookCategory {
    _id: string;
    category: Entity;
    priceVariance: number;
}


export interface PriceBookCodeException {
    _id: string;
    code: Entity;
    price: number;
}

export interface PriceBookGeneralLedger {
    _id: string;
    expenseGL: string;
    incomeGL: string;
}

export interface PriceListRule extends Entity {
    itemType?: CodeType;
    codeCategories?: CodeCategory[];
    pricingMethod: PricingMethod,
    pricingValue?: number,
    pricingReference?: Entity,
    sortOrder: number;
}

export interface WorkRoleOverride {
    _id: string;
    role: Entity;
    sellRate: number;
}

export interface PriceBook extends Entity {

    tenantId: string;
    // type: PriceBookType;
    mode: PriceListMode;
    category: PriceListCategory;
    description: string;

    dateStart: Date;
    dateEnd: Date;
    company?: Entity;

    // This is being used to store supplier
    // We will migrate custoemr and technician into this field when we go to CRM PRo
    account?: Entity;

    customer?: Entity;
    technician?: Entity;

    parentOnly: boolean;

    parent?: Entity;
    defaultPriceVariance: number;
    isDefault: boolean;

    zones?: Entity[];
    jobTypes?: Entity[];
    priorities?: Entity[];
    categoryCoverages?: Entity[];
    customerCoverages?: Entity[];
    companyCoverages?: Entity[];
    workCategoryCoverages?: Entity[];

    categories?: PriceBookCategory[];

    dynamicRules?: PriceListRule[];
    workRoleOverrides?: WorkRoleOverride[];
}


export interface PriceListSummary extends Entity {

    category: PriceListCategory;
    status: PricelistStatus;
    mode: PriceListMode;
    // type: PriceBookType;
    description: string;

    account: Entity;
    company: Entity;

    dateStart: Date;
    dateEnd: Date;

    parentOnly: boolean;
    group?: PriceListCategory | 'Global';
}

export interface PriceListEntityRequest {
    includeGlobal: boolean,
    accountId: string,
    companyId: string,
    category: PriceListCategory,
    coverage?: PriceListCoverageParameters
}

export interface PriceListEntity extends Entity {
    category: PriceListCategory;
    group: PriceListCategory | 'Global' | 'Recommended';
    dateStart: Date;
    dateEnd: Date;
    company: Entity;
}

export interface PriceListEntityCoverage extends PriceListEntity {
    zones?: Entity[];
    jobTypes?: Entity[];
    priorities?: Entity[];
    categoryCoverages?: Entity[];
    customerCoverages?: Entity[];
    companyCoverages?: Entity[];
    workCategoryCoverages?: Entity[];
}

// export const typeFromCategory = {
//     [PriceListCategory.Contractor]: PriceBookType.Buy,
//     [PriceListCategory.Supplier]: PriceBookType.Buy,
//     [PriceListCategory.Customer]: PriceBookType.Sell,
// };


export enum PricingReloadType {
    All = 'All',
    Codes = 'Codes',
    DynamicRules = 'DynamicRules',
    CodePrices = 'CodePrices'
}

export interface PriceListCoverageParameters {
    zones?: Entity[];
    jobType?: Entity;
    jobPriority?: Entity;
    itemCategories?: Entity[];
    company: Entity;
    customer: Entity;
    workCategory: Entity;
}

export type DefaultPriceListRequest = {

    /** @description ActivityEntityName.JobTemplate | ActivityEntityName.Account | ActivityEntityName.SitePro */
    entity?: ActivityEntityName;

    jobTemplateId?: string;
    customerId?: string;
    siteId?: string;
}

export interface DefaultPriceListResponse {
    pricelist: Entity,
    billingCompanyOverride?: Entity;
    source?: ActivityEntityName.JobTemplate | ActivityEntityName.Account | ActivityEntityName.SitePro;
}